/** Turns an impacts API error into a user-facing French message. */
export const getImpactErrorMessage = (err) => {
  const status = err?.response?.status;
  const detail = err?.response?.data?.detail;
  const text = typeof detail === "string" ? detail : "";

  // duplicate reference
  if (status === 409 || /already exists/i.test(text)) {
    const ref = text.match(/reference '([^']+)'/i)?.[1];
    return ref
      ? `La référence « ${ref} » existe déjà. Utilisez une autre référence ou supprimez l’analyse existante.`
      : "Cette référence existe déjà. Utilisez une autre référence ou supprimez l’analyse existante.";
  }

  // simulated fire smaller than the real fire -> polygons probably swapped
  if (/simulated fire/i.test(text) && /smaller than the real fire/i.test(text)) {
    const areas = text.match(
      /simulated fire \(([\d.]+) ha\).*real fire \(([\d.]+) ha\)/i,
    );
    const [, simHa, realHa] = areas ?? [];
    return simHa && realHa
      ? `Le polygone menacé (${simHa} ha) est plus petit que le polygone sinistré (${realHa} ha). Le feu simulé doit être au moins aussi grand que le feu réel : vérifiez que les deux polygones n’ont pas été inversés.`
      : "Le polygone menacé est plus petit que le polygone sinistré. Vérifiez que les deux polygones n’ont pas été inversés.";
  }

  return "Impossible de lancer l'analyse.";
};
